import { handleFailToast } from 'api/utils/errorHandler';
import { ALLOWED_DOMAINS } from 'auth/constants';
import { t } from 'i18next';

export const sendAuthMessage = (message: AuthMessage) => {
  try {
    // 현재 도메인이 3000이면 3002로, 3002면 3000으로 보내기
    const targetPort = window.location.port === '3000' ? '3002' : '3000';
    const targetDomain = `http://localhost:${targetPort}`;

    // 새 창 열기 (작은 팝업으로)
    const targetWindow = window.open(targetDomain, 'auth_popup', 'width=1,height=1,left=-1000,top=-1000');

    // 메시지 전송
    if (targetWindow) {
      targetWindow.postMessage(message, targetDomain);
    }
  } catch (error) {
    console.error('Error sending auth message:', error);
  }
};

export function endLoadingAndErrorToast(error?: any) {
  error && console.log({ error });
  const isBlockedUser = error?.code === 'BLOCKED';
  //   setLoading(false);
  if (isBlockedUser) {
    handleFailToast(t('general.contact_customer_support_error_message'));
  } else {
    handleFailToast(t('general.contact_customer_support_error_message'));
  }
}
